import { Component, OnInit, ViewChild } from '@angular/core';
import { TabsetComponent } from 'ngx-bootstrap/tabs';
import { AdminService } from '../../../services/admin.service';
import {HumanInteractionService} from '../../../services/human-interaction.service';
import {BusinessProcessService} from '../../../services/business-process.service';

@Component({
  selector: 'app-sequential-allocation',
  templateUrl: './sequential-allocation.component.html',
  styleUrls: ['./sequential-allocation.component.css']
})
export class SequentialAllocationComponent implements OnInit {

  hasCustomQueuePermission = false;
  hasRegularQueuePermission = false;
  isOnInit = true;
  progressAllocation = false;
  progressCustomAllocation = false;
  progressAllocationMessage = '';
  progressCustomAllocationMessage = '';
  errorMessage = '';
  @ViewChild('sequentialAllocationTabs', { static: false }) sequentialAllocationTabs: TabsetComponent;

  constructor(
    private admService: AdminService,
    private humanInteractionService: HumanInteractionService,
    private bpService: BusinessProcessService

  ) { }

  ngOnInit() {
    this.checkItemsRight(24);
    this.checkItemsRight(28);
  }

  checkItemsRight(item: number) {
    this.errorMessage = '';
    this.admService.checkItemsRight(item)
      .subscribe( hasRight => {
        this.isOnInit = false;
        switch (item) {
          case 24:
            this.hasRegularQueuePermission = hasRight;
            break;
          case 28:
            this.hasCustomQueuePermission = hasRight;
            break;
        }
      }, error1 => this.errorMessage = error1);
  }

  tryAllocate() {
    this.progressAllocationMessage = '';
    this.progressAllocation = true;
    this.progressAllocationMessage = 'Alocando a próxima instância disponível...';

    this.humanInteractionService.allocateNextInstance().subscribe( instanceId => {
      if (!instanceId) {
        this.progressAllocation = false;
        this.progressAllocationMessage = 'Não existem instâncias disponíveis para interação neste momento.';
        this.clearProgressAllocationMessage();
        return;
      }
      this.progressAllocationMessage = 'Aguarde. Redirecionando para a tela de interação...';
      this.clearProgressAllocationMessage();
      this.bpService.openWindowInteraction(instanceId, false, 5);
    }, error => {
      this.progressAllocationMessage = 'Não foi possível alocar uma instância. Detalhes: '+ error;
      this.progressAllocation = false;
    });
  }

  tryAllocateCustom(){
    this.progressCustomAllocationMessage = '';
    this.progressCustomAllocation = true;
    this.progressCustomAllocationMessage = 'Alocando a próxima instância disponível...';

    this.humanInteractionService.allocateNextInstanceCustom().subscribe( instanceId => {
      if (!instanceId) {
        this.progressCustomAllocation = false;
        this.progressCustomAllocationMessage = 'Não existem instâncias disponíveis para interação neste momento.';
        this.clearProgressAllocationCustomMessage();
        return;
      }
      this.progressCustomAllocationMessage = 'Aguarde. Redirecionando para a tela de interação...';
      this.clearProgressAllocationCustomMessage();
      this.bpService.openWindowInteraction(instanceId, false, 7);
    }, error => {
      this.progressCustomAllocationMessage = 'Não foi possível alocar uma instância. Detalhes: '+ error;
      this.progressCustomAllocation = false;
    });
  }

  clearProgressAllocationMessage(){
    setTimeout(() => {
      this.progressAllocation = false;
      this.progressAllocationMessage = '';
    }, 2000);
  }
  clearProgressAllocationCustomMessage(){
    setTimeout(() => {
      this.progressCustomAllocation = false;
      this.progressCustomAllocationMessage = '';
    }, 2000);
  }
}
